export const membershipRoutes = {
	children: [{
		component: () => import(`@/view/membership/Create.vue`),
		meta: { hasRole: [ `club:admin` ] },
		name: `CreateMembership`,
		path: `club/:clubId/create`
	}],
	component: () => import(`@/view/OneSidebar.vue`),
	path: `/membership`
};
